import React from 'react';
import './App.less';
import { HashRouter, Route } from 'react-router-dom';
import Home from './pages/Home/index';
import Header from './components/Header';
import Detail from './pages/Detail';
import User from './pages/User';
import Collect from './pages/Collect';

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Header />
      </HashRouter>
      <div className="container">
        <HashRouter>
          <Route exact path="/" component={Home} />
          <Route path="/topic/:id" component={Detail} />
          <Route path="/user/:username" component={User} />
          <Route path="/collect" component={Collect} />
        </HashRouter>
      </div>
    </div>
  );
}

export default App;
